import React, { useEffect, useRef, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import sliderBG from "../images/v2/careers/Front_banner.svg";
import IdeaAndInnovation from "../images/v2/careers/Idea-and-Innovation.svg";
import BoundariesAndBeyond from "../images/v2/careers/Boundaries and Beyond.svg";
import DiversionAndInclusion from "../images/v2/careers/Diversion and Inclusion.svg";
import FreeAndFun from "../images/v2/careers/Free and Fun.svg";
import ProfessionalAndPersonal from "../images/v2/careers/Professional and Personal.svg";
import SingleAndSquad from "../images/v2/careers/Single and Squad.svg";
import lifeAtPepperIcon1 from "../images/v2/careers/lifeAtPepperIcon1.svg";
import lifeAtPepperIcon2 from "../images/v2/careers/lifeAtPepperIcon2.svg";
import lifeAtPepperIcon3 from "../images/v2/careers/lifeAtPepperIcon3.svg";
import lifeAtPepperIcon4 from "../images/v2/careers/lifeAtPepperIcon4.svg";
import lifeAtPepperIcon5 from "../images/v2/careers/lifeAtPepperIcon5.svg";
import lifeAtPepperIcon6 from "../images/v2/careers/lifeAtPepperIcon6.svg";
import OurPrinciples2 from "../images/v2/careers/OurPrinciples2.svg";
import OurPrinciples3 from "../images/v2/careers/OurPrinciples3.svg";
import OurPrinciples4 from "../images/v2/careers/OurPrinciples4.svg";
import OurPrinciples5 from "../images/v2/careers/OurPrinciples5.svg";
import OurPrinciples6 from "../images/v2/careers/OurPrinciples6.svg";
import Footer_background from "../images/v2/careers/Footer_background.svg";
import CareersImg from "../images/v2/careers/Careers-2-bg.svg";
import Grid from "@material-ui/core/Grid";
import HeaderTypography from "../components/v2/Typography/HeaderTypography";
import ParagraphTypography from "../components/v2/Typography/ParagraphTypography";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import { Typography } from "@material-ui/core";
import FeaturedOpening from "../components/v2/Careers/FeaturedOpening";
import TakeOwnership from "../images/v2/careers/Take Ownership.svg";
import BeProactive from "../images/v2/careers/Be Proactive.svg";
import BeTransparent from "../images/v2/careers/Be Transparent.svg";
import BePatient from "../images/v2/careers/Be patient.svg";
import BeEmpathetic from "../images/v2/careers/Be Empathetic.svg";
import StayCommitted from "../images/v2/careers/Stay Committed.svg";
import OurOffice from "../components/v2/OurOffice";
import Artboard from "../images/v2/careers/Artboard.svg";
import Beginyourjourney from "../images/v2/careers/Begin your journey.webp";
import floatingImg1 from "../images/v2/careers/floatingImg1.webp";
import floatingImg2 from "../images/v2/careers/floatingImg2.webp";
import floatingImg3 from "../images/v2/careers/floatingImg3.webp";
import floatingImg4 from "../images/v2/careers/floatingImg4.webp";
import floatingImg5 from "../images/v2/careers/floatingImg5.webp";
import floatingImg6 from "../images/v2/careers/floatingImg6.webp";
import floatingImg7 from "../images/v2/careers/floatingImg7.webp";
import jobsBg from "../images/v2/careers/jobsBg.webp";
import WhiteButton from "../components/v2/WhightButton";
import JoinUs from "../components/v2/JoinUs";
import useWidth from "../hooks/useWidth";
import SEO from "../components/SEO";
import { motion, useScroll, useTransform } from "framer-motion";

const useStyles = makeStyles((theme) => ({
  heroSection: {
    position: "relative",
    background: "radial-gradient(circle at 100% 0%, rgba(130, 191, 244, 0.5) 0%, transparent 20%), radial-gradient(circle at 0% 10%, rgba(130, 191, 244, 0.5) 0%, transparent 24%),radial-gradient(circle at 98% 70%, rgba(0, 154, 153, 0.4) 0%, transparent 12%), linear-gradient(180deg, rgba(190, 231, 231, 1) 0%, rgba(255, 255, 255, 1) 100%)",
    overflow: "hidden",
    minHeight: 700,
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      minHeight: "fit-content",
    },
  },
  heroContent: {
    position: "relative",
    zIndex: 1,
    textAlign: "center",
    padding: "80px 0",
    [theme.breakpoints.down("sm")]: {
      padding: "48px 0",
    },
  },
  floatingImg: {
    position: "absolute",
    borderRadius: "16px",
    objectFit: "cover",
    boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
    cursor: "pointer",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  heroBtn: {
    borderRadius: "50px",
    padding: "14px 36px",
    fontSize: "16px",
    fontWeight: 600,
    textTransform: "none",
    [theme.breakpoints.down("sm")]: {
      padding: "12px 28px",
      fontSize: "15px",
    },
  },
  applyRoot: {
    background: `url(${CareersImg})`,
    backgroundSize: "cover",
    backgroundPosition: "bottom",
    // background: `url(${CareersImg})`,
    // backgroundSize: "cover",
    // backgroundPosition: "center",
    // minHeight: 646,
  },
  BeginUsJourneyRoot: {
    background: `url(${sliderBG})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    minHeight: 646,
  },
  JoinUsRoot: {
    background: `url(${Footer_background})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
  large: {
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
  integrationRoot: {
    backgroundColor: "#f2f9f9",
    padding: "4rem 0",
    [theme.breakpoints.down("sm")]: {
      marginTop: 0,
      padding: 0,
    },
  },
  ourPrinciples: {
    border: "1px solid",
    borderRadius: theme.shape.borderRadius * 2.5,
    borderColor: "#e2f0ff",
    padding: theme.spacing(4),
    minHeight: "320px",
  },
  bannerHeading: {
    fontSize: "64px",
    fontWeight: 600,
    lineHeight: 1.2,
    marginBottom: "48px !important",
    "@media(max-width:1024px)": {
      fontSize: "48px",
    },
    "@media(max-width:600px)": {
      fontSize: "34px",
      marginBottom: "32px !important",
    },
  },
  sectionTitle: {
    fontSize: "56px",
    fontWeight: 600,
    lineHeight: 1.2,
    marginBottom: "48px !important",
    "@media(max-width:1200px)": {
      fontSize: "48px",
    },
    "@media(max-width:992px)": {
      fontSize: "40px",
    },
    "@media(max-width:600px)": {
      fontSize: "32px",
      marginBottom: "32px !important",
    },
  },
  sectionSubheading: {
    fontSize: "18px",
    fontWeight: 500,
    "@media(max-width:600px)": {
      fontSize: "16px",
    },
  },
  cardIconBox: {
    width: "52px",
    height: "52px",
    borderRadius: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "20px",
    "@media(max-width:600px)": {
      width: "44px",
      height: "44px",
      borderRadius: "10px",
      marginBottom: "16px",
    },
  },
  cardIconImg: {
    width: "auto",
    height: "24px",
    filter: "brightness(0) invert(1)",
    "@media(max-width:600px)": {
      width: "22px",
    },
  },
  principlesImage: {
    width: "100%",
    maxWidth: 430,
    height: "auto",
    borderRadius: "16px",
    display: "block",
    marginLeft: 0,
    marginRight: 0,
    [theme.breakpoints.down("sm")]: {
      marginLeft: "auto",
      marginRight: "auto",
    },
  },
  lifeAtPepperSection: {
    background: "radial-gradient(ellipse 18% 50% at 22% 55%, rgba(0, 154, 153, 0.3) 0%, transparent 100%), radial-gradient(ellipse 18% 50% at 50% 55%, rgba(32, 142, 236, 0.3) 0%, transparent 100%), radial-gradient(ellipse 18% 50% at 78% 55%, rgba(0, 154, 153, 0.3) 0%, transparent 100%), transparent",
    [theme.breakpoints.down("sm")]: {
      background: "radial-gradient(ellipse 70% 20% at 50% 18%, rgba(0, 154, 153, 0.3) 0%, transparent 100%), radial-gradient(ellipse 70% 20% at 50% 50%, rgba(32, 142, 236, 0.3) 0%, transparent 100%), radial-gradient(ellipse 70% 20% at 50% 82%, rgba(0, 154, 153, 0.3) 0%, transparent 100%), transparent",
      display: "flex",
      flexDirection: "column",
    },
  },
  lifeAtPepperCard: {
    background: "white",
    borderRadius: "16px",
    padding: "28px 24px",
    boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
    height: "100%",
    boxSizing: "border-box",
    overflow: "hidden",
    position: "relative",
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
    "&:hover": {
      transform: "translateY(-4px)",
      boxShadow: "0 12px 32px rgba(0,0,0,0.12)",
    },
    "&.glass-effect": {
      "&::before": {
        content: '""',
        position: "absolute",
        width: "300px",
        height: "300px",
        zIndex: "0",
        background: "var(--before-gradient)",
        borderRadius: "50%",
        filter: "blur(80px)",
        opacity: "var(--before-opacity, 0)",
        left: "var(--before-left, 0)",
        top: "var(--before-top, 0)",
        transition: "opacity 0.3s ease",
        pointerEvents: "none",
      },
    },
    "& > *": {
      position: "relative",
      zIndex: "1",
    },
  },
  applyBtn: {
    width: 336,
    height: 73,
    fontWeight: 600,
    fontSize: 20,
  },
  header: {
    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
    },
  },
  whyChoose: {
    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
      height: "unset",
      paddingLeft: "unset",
    },
  },
  beginJourney: {
    [theme.breakpoints.down("sm")]: {
      marginBottom: 0,
    },
  },
  careerPara: {
    fontSize: "18px",
    maxWidth: "720px",
    color: "#000",
    fontWeight: "400",
  },
  thrivePhotoWrapper: {
    border: "1px solid rgba(32, 142, 236, 0.5)",
    borderRadius: "24px",
    padding: "20px",
    background: "rgba(32, 142, 236, 0.1)",
    width: "100%",
    maxWidth:'850px',
     [theme.breakpoints.down("sm")]: {
      padding: "16px",
     }
  },
  thrivePhotoGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(4, 1fr)",
    gap: "14px",
    alignItems: "start",
    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: "repeat(2, 1fr)",
    },
  },
  thriveRatingCard: {
    background: "white",
    borderRadius: "24px",
    padding: "16px 12px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height:'100%'
  },
  thriveBrandName: {
    fontWeight: 600,
    fontSize: "13px",
    marginTop: "6px",
    color: "#1a1a1a",
  },
  thriveStarsRow: {
    display: "flex",
    alignItems: "center",
    gap: "1px",
    marginTop: "4px",
  },
  thriveStar: {
    color: "#FF8C00",
    fontSize: "15px",
    lineHeight: 1,
  },
  thriveStarHalfOuter: {
    position: "relative",
    display: "inline-block",
    color: "#e0e0e0",
    fontSize: "15px",
    lineHeight: 1,
  },
  thriveStarHalfInner: {
    position: "absolute",
    left: 0,
    top: 0,
    overflow: "hidden",
    width: "50%",
    color: "#FF8C00",
  },
  thriveScoreRow: {
    display: "flex",
    alignItems: "baseline",
    gap: "2px",
    marginTop: "4px",
  },
  thriveScoreNumber: {
    fontSize: "22px",
    fontWeight: 700,
    lineHeight: 1,
    color: "#1a1a1a",
  },
  thriveScoreDenom: {
    fontSize: "12px",
    color: "#888",
  },
  thrivePhoto: {
    width: "100%",
    height: "100%",
    display: "block",
    borderRadius: "20px",
    boxShadow: "0 8px 10px rgba(0,0,0,0.06)",
    [theme.breakpoints.down("sm")]: {
      borderRadius: "14px",
      objectFit: "cover",
    },
  },
  thrivePhotoTall: {
    width: "100%",
    height: "100%",
    display: "block",
    gridRow: "span 2",
    borderRadius: "20px",
    [theme.breakpoints.down("sm")]: {
      gridRow: "span 1",
      borderRadius: "14px",
      objectFit: "cover",
    },
  },
  thrivePhotoWide: {
    width: "100%",
    height: "100%",
    display: "block",
    gridColumn: "span 2",
    borderRadius: "20px",
    [theme.breakpoints.down("sm")]: {
      gridColumn: "span 1",
      borderRadius: "14px",
      objectFit: "cover",
    },
  },
  "@keyframes shimmer": {
    "0%":   { backgroundPosition: "200% 0" },
    "100%": { backgroundPosition: "-200% 0" },
  },
  thrivePhotoCell: {
    position: "relative",
  },
  thrivePhotoCellWide: {
    position: "relative",
    gridColumn: "span 2",
    [theme.breakpoints.down("sm")]: { gridColumn: "span 2" },
  },
  thrivePhotoCellTall: {
    position: "relative",
    gridRow: "span 2",
    [theme.breakpoints.down("sm")]: { gridRow: "span 1" },
  },
  thrivePhotoSkeleton: {
    position: "absolute",
    inset: 0,
    borderRadius: "20px",
    background: "linear-gradient(90deg, #dde8f5 25%, #eef4fb 50%, #dde8f5 75%)",
    backgroundSize: "200% 100%",
    animation: "$shimmer 1.5s ease-in-out infinite",
    zIndex: 0,
    [theme.breakpoints.down("sm")]: { borderRadius: "14px" },
  },
  featuredJobsSection: {
    position: "relative",
  },
  featuredJobsBgImg: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "auto",
    display: "block",
    zIndex: 0,
  },
  featuredJobsGradient: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "linear-gradient(180deg, rgba(0,33,61,0.1) 0%, rgba(0,33,61,1) 90vh)",
    zIndex: 1,
    [theme.breakpoints.down("md")]: {
      background: "linear-gradient(180deg, rgba(0,33,61,0.1) 0%, rgba(0,33,61,1) 60vh)",
    },
    [theme.breakpoints.down("sm")]: {
      background: "linear-gradient(180deg, rgba(0,33,61,0.1) 0%, rgba(0,33,61,1) 45vh)",
    },
    [theme.breakpoints.down("xs")]: {
      background: "linear-gradient(180deg, rgba(0,33,61,0.1) 0%, rgba(0,33,61,1) 24vh)",
    },
  },
  featuredJobsContent: {
    position: "relative",
    zIndex: 2,
    padding: "55vh 0 72px",
    textAlign: "center",
  },
  featuredJobsTitle: {
    fontSize: "56px",
    fontWeight: 600,
    color: "#ffffff",
    lineHeight: 1.2,
    marginBottom: "48px !important",
    "@media(max-width:1200px)": {
      fontSize: "48px",
    },
    "@media(max-width:992px)": {
      fontSize: "40px",
    },
    "@media(max-width:600px)": {
      fontSize: "32px",
      marginBottom: "32px !important",
    },
  },
  featuredJobsDesc: {
    fontSize: "18px",
    fontWeight: 500,
    color: "rgba(255,255,255,0.85)",
    maxWidth: "640px",
    margin: "0 auto",
    "@media(max-width:600px)": {
      fontSize: "16px",
    },
  },
}));

function careers() {
  const width = useWidth();
  const classes = useStyles();
  const [open, setOpen] = useState(-1);

  // Scroll-driven grid entry animation
  const thriveGridRef = useRef(null);
  const { scrollYProgress: thriveScroll } = useScroll({
    target: thriveGridRef,
    offset: ["start end", "start 0.3"],
  });

  // X in vw  (hero left/right % → viewport-relative offset from grid cell)
  // Y in vh  (proportional to image height within hero section)

  // floatingImg2 — hero: top:54% left:6%  rotate:-8deg → grid: col1 row1
  const img2Y = useTransform(thriveScroll, [0, 1], ["-62vh", "0vh"]);
  const img2X = useTransform(thriveScroll, [0, 1], ["-25vw", "0vw"]);
  const img2R = useTransform(thriveScroll, [0, 1], ["-8deg", "0deg"]);

  // floatingImg5 — hero: bottom:8% left:12% rotate:-5deg → grid: col2-3 row1 (wide)
  const img5Y = useTransform(thriveScroll, [0, 1], ["-40vh", "0vh"]);
  const img5X = useTransform(thriveScroll, [0, 1], ["-35vw", "0vw"]);
  const img5R = useTransform(thriveScroll, [0, 1], ["-5deg", "0deg"]);

  // floatingImg4 — hero: top:25% right:-1% rotate:4deg → grid: col4 row1-2 (tall)
  const img4Y = useTransform(thriveScroll, [0, 1], ["-88vh", "0vh"]);
  const img4X = useTransform(thriveScroll, [0, 1], ["30vw", "0vw"]);
  const img4R = useTransform(thriveScroll, [0, 1], ["4deg", "0deg"]);

  // floatingImg6 — hero: top:24% left:0% rotate:-8deg → grid: col1 row2
  const img6Y = useTransform(thriveScroll, [0, 1], ["-120vh", "0vh"]);
  const img6X = useTransform(thriveScroll, [0, 1], ["-30vw", "0vw"]);
  const img6R = useTransform(thriveScroll, [0, 1], ["-8deg", "0deg"]);

  // floatingImg7 — hero: bottom:14% right:6% rotate:6deg → grid: col2 row2
  const img7Y = useTransform(thriveScroll, [0, 1], ["-72vh", "0vh"]);
  const img7X = useTransform(thriveScroll, [0, 1], ["52vw", "0vw"]);
  const img7R = useTransform(thriveScroll, [0, 1], ["6deg", "0deg"]);

  // floatingImg3 — hero: bottom:6% right:30% rotate:12deg → grid: col3 row2
  const img3Y = useTransform(thriveScroll, [0, 1], ["-65vh", "0vh"]);
  const img3X = useTransform(thriveScroll, [0, 1], ["10vw", "0vw"]);
  const img3R = useTransform(thriveScroll, [0, 1], ["12deg", "0deg"]);

  // Scale grows from thumbnail size to full grid size; skeleton fades out as images land
  const imgScale  = useTransform(thriveScroll, [0, 1], [0.8, 1]);
  const skeletonO = useTransform(thriveScroll, [0.6, 1], [1, 0]);

  // Cursor-tracking glow hover effect on Life at Pepper Cloud cards
  // (mirrors the .benefitCard effect from edge-grant.js)
  useEffect(() => {
    const cards = document.querySelectorAll(`.${classes.lifeAtPepperCard}`);

    const gradients = [
      "rgba(0, 154, 153, 0.25)",
      "rgba(158, 90, 213, 0.25)",
      "rgba(32, 142, 236, 0.25)",
    ];

    const cleanups = [];

    cards.forEach((card, index) => {
      card.classList.add("glass-effect");
      card.style.setProperty("--before-gradient", gradients[index % 3]);

      const setInitialPosition = () => {
        const rect = card.getBoundingClientRect();
        card.style.setProperty("--before-left", `${rect.width - 150}px`);
        card.style.setProperty("--before-top", "0px");
        card.style.setProperty("--before-opacity", "0");
      };

      setInitialPosition();

      let lastX = null;
      let lastY = null;

      const handleMouseMove = (e) => {
        const rect = card.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        lastX = x;
        lastY = y;
        card.style.setProperty("--before-left", `${x - 150}px`);
        card.style.setProperty("--before-top", `${y - 150}px`);
      };

      const handleMouseEnter = () => {
        if (lastX !== null && lastY !== null) {
          card.style.setProperty("--before-left", `${lastX - 150}px`);
          card.style.setProperty("--before-top", `${lastY - 150}px`);
        }
        card.style.setProperty("--before-opacity", "1");
      };

      const handleMouseLeave = () => {
        card.style.setProperty("--before-opacity", "0");
      };

      card.addEventListener("mousemove", handleMouseMove);
      card.addEventListener("mouseenter", handleMouseEnter);
      card.addEventListener("mouseleave", handleMouseLeave);
      window.addEventListener("resize", setInitialPosition);

      cleanups.push(() => {
        card.removeEventListener("mousemove", handleMouseMove);
        card.removeEventListener("mouseenter", handleMouseEnter);
        card.removeEventListener("mouseleave", handleMouseLeave);
        window.removeEventListener("resize", setInitialPosition);
      });
    });

    return () => {
      cleanups.forEach((fn) => fn());
    };
  }, [classes.lifeAtPepperCard]);

  const LifeAtPepperCloud = [
    {
      title: "Boundaries and beyond",
      description:
        "Be your own boss and push your boundaries. Feel the independence and be driven by your goals.",
      logo: lifeAtPepperIcon2,
      alt: "Icon to indicate life at Pepper Cloud CRM",
      color: "#F68151",
    },
    {
      title: "Professional and personal",
      description:
        "Strike the right balance between your professional and personal life with flexible working hours.",
      logo: lifeAtPepperIcon1,
      alt: "Icon to indicate the importance of work-life balance and the right time in CRM career",
      color: "#9E5AD5",
    },
    {
      title: "Diversity and inclusion",
      description:
        "Be a part of a workplace that is inclusive of gender equality and cultural diversity.",
      logo: lifeAtPepperIcon5,
      alt: "Icon to indicate diversity and inclusion at Pepper Cloud",
      color: "#009A99",
    },
    {
      title: "Single and squad",
      description:
        "Be recognised, appreciated, and encouraged for your individual efforts and for your team efforts.",
      logo: lifeAtPepperIcon6,
      alt: "CRM professional icon",
      color: "#0291AE",
    },
    {
      title: "Free and fun",
      description:
        "Experience the joy of all sorts of fun - from casual banter to playful outings, to career growth opportunities.",
      logo: lifeAtPepperIcon3,
      alt: "Icon to indicate a CRM professional having fun",
      color: "#009A99",
    },
    {
      title: "Idea and innovation",
      description:
        "Be a unique clouder among other young, lively, and innovative clouders.",
      logo: lifeAtPepperIcon4,
      alt: "Bulb icon to indicate innovation in CRM",
      color: "#1778CA",
    },
  ];
  const OurPrinciples = [
    {
      title: "Take Ownership",
      description:
        "Take ownership of your work and emotions. Ownership brings a sense of independence, attachment, and confidence.",
      logo: lifeAtPepperIcon2,
      alt: "Icon to indicate taking ownership in their CRM career",
      color: "#F68151",
    },
    {
      title: "Be Proactive",
      description:
        "Be proactive in handling your roles and responsibilities. Productiveness leads to innovation and great ideas.",
      logo: OurPrinciples2,
      alt: "A glowing bulb icon inidate proactiveness to grow in CRM career path",
      color: "#1D8DEE",
    },
    {
      title: "Be Transparent",
      description:
        "Be communicative about your ideas and transparent in your work. Transparency leads to trust, a collaborative work environment, and great relationships.",
      logo: OurPrinciples3,
      alt: "A shield icon to indicate being communicative",
      color: "#019392",
    },
    {
      title: "Be Patient",
      description:
        "Be patient while thinking, analysing, strategising, and delivering. Patience can lead to the creation of unique products.",
      logo: OurPrinciples4,
      alt: "Hourglass icon indicating the need of patience to grow in CRM career.",
      color: "#9E5AD5",
    },
    {
      title: "Be Empathetic",
      description:
        "Be empathetic towards your acquaintances. Empathy brings harmony in the workplace, with unexplored potential to make and feel better.",
      logo: OurPrinciples5,
      alt: "Connected minds to indicate being empathetic",
      color: "#0291AE",
    },
    {
      title: "Stay Committed",
      description:
        "Be committed to the chosen path. Commitment, with a certain extent of flexibility and remodelling, boosts productivity and efficiency.",
      logo: OurPrinciples6,
      alt: "Hand shake icon to indicate the commitment to CRM career path",
      color: "#1778CA",
    },
  ];

  const jobDetails = [
    {
      position: "Technical Lead",
      location: "Engineering Team, Bengaluru",
      applyLink:
        "https://angel.co/company/pepper-cloud-pte-1/jobs/1749534-technical-lead",
      open: false,
      content: (
        <React.Fragment>
          <Box fontSize="16px">
            We are looking for an experienced and passionate technical lead to
            design, develop and enhance our core product offerings.
            <ul>
              <li>
                As a senior member of the technology team, you will play a
                critical role in leading the design architecture, product
                development and technical strategy.
              </li>
              <li>
                You will take significant ownership of our core platform and
                architect it for speed and scalability. In short, you will be
                responsible for translating ideas, concept images and business
                requirements to an enterprise-grade product.
              </li>
            </ul>
          </Box>
          <Box fontSize="18px" mb="10px" mt="10px">
            Basic Qualifications:
          </Box>
          <Box fontSize="16px">
            <ul>
              <li>
                3+ years of hands-on experience in designing, developing and
                managing products
              </li>
              <li>
                4+ years of experience in shipping reliable, scalable, and
                efficient code, preferably in a full-stack role
              </li>
              <li>
                Solid experience in technical architecture and implementation of
                scalable web applications
              </li>
              <li>
                Deep understanding of the JavaScript language and hands-on
                experience with modern JavaScript UI libraries, frameworks and
                design
              </li>
              <li>patterns (React, Angular, Node, Redux, Saga)</li>
              <li>
                Proven expertise in growing a product centric team and culture
              </li>
              <li>
                Excellent people management, analytical and communication skills
              </li>
            </ul>
          </Box>
          <Box fontSize="18px" mb="10px" mt="10px">
            Desirable Skills:
          </Box>
          <Box fontSize="16px">
            <ul>
              <li>
                Experience in designing and developing enterprise-grade SaaS
                applications
              </li>
              {/* eslint-disable-next-line react/no-unescaped-entities */}
              <li>Start-up experience</li>
              <li>"Get things done" attitude.</li>
              <li>Experience working with remote teams</li>
            </ul>
          </Box>
          <Box fontSize="18px" mb="10px" mt="10px">
            Benefits:
          </Box>
          <Box fontSize="16px">
            <ul>
              <li>Competitive salary</li>
              <li>Key product management role in a strong and growing team</li>
              <li>Flexible work hours and holiday policy</li>
              <li>Open and collaborative work culture</li>
            </ul>
          </Box>
        </React.Fragment>
      ),
    },
    {
      position: "Full Stack Engineer",
      location: "Engineering Team, Bengaluru",
      applyLink:
        "https://angel.co/company/pepper-cloud-pte-1/jobs/1743375-full-stack-engineer",
      open: false,
      content: (
        <React.Fragment>
          <Box fontSize="16px">
            We are looking for a passionate
            <ul>
              <li>
                Software Engineer to design, develop, and scale our core product
                offerings. As a core member of the technology team, you will
                play a critical role in creating responsive frontend interfaces,
                building backend platform services and streamlining the build
                infrastructure.
              </li>
              <li>
                Right from the start, you will take significant ownership of
                parts of the platform and continuously involved in product
                planning and strategy. In short, you will wear many hats, touch
                many parts of our system, and play an instrumental role in
                shaping our product suite.
              </li>
            </ul>
          </Box>
          <Box fontSize="18px" mb="10px" mt="10px">
            Basic Qualifications:
          </Box>
          <Box fontSize="16px">
            <ul>
              <li>
                Minimum of 3 years of software engineering experience,
                preferably in an isomorphic/universal JavaScript environment
              </li>
              <li>
                Practical experience with modern JavaScript libraries and
                frameworks (including but not limited to React, Angular,
                Express, Sails, Redux)
              </li>
              <li>
                Solid understanding of the JavaScript language (ECMAScript
                2015+), HTML5 and CSS
              </li>
              <li>Strong knowledge of RESTful API design and implementation</li>
              <li>
                Experience with unit testing, continuous integration and
                deployment preferred
              </li>
              <li>
                Basic understanding of Javascript build and automation tools
                (e.g., Webpack, Grunt, etc.)
              </li>
            </ul>
          </Box>
          <Box fontSize="18px" mb="10px" mt="10px">
            Desirable Skills:
          </Box>
          <Box fontSize="16px">
            <ul>
              <li>Start-up experience</li>
              <li>Mobile development experience a solid plus</li>
              {/* eslint-disable-next-line react/no-unescaped-entities */}
              <li>Experience with microservices-based architecture a plus</li>
              <li>"Get things done" attitude.</li>
            </ul>
          </Box>
          <Box fontSize="18px" mb="10px" mt="10px">
            Benefits:
          </Box>
          <Box fontSize="16px">
            <ul>
              <li>Competitive salary</li>
              <li>Key role in a small but strong and growing team</li>
              <li>Flexible work hours and holiday policy</li>
              <li>Open and collaborative work culture</li>
            </ul>
          </Box>
        </React.Fragment>
      ),
    },
    {
      position: "Frontend Developer",
      location: "Engineering Team, Bengaluru",
      applyLink:
        "https://angel.co/company/pepper-cloud-pte-1/jobs/1743380-frontend-developer",
      open: false,
      content: (
        <React.Fragment>
          <Box fontSize="16px">
            We are looking for an experienced and passionate frontend developer
            to design and develop our core product offerings. You will be a core
            member of the engineering team who can:
            <ul>
              <li>
                As a core member of the technology team, you will play a
                critical role in creating responsive user interfaces and
                implementing functional UI from concept images and wireframes.
              </li>
              <li>
                You will take significant ownership of the frontend platform and
                architect it for speed and scalability.
              </li>
              <li>
                Working closely with design and backend team, you will help
                establish a shared UI vision for our product suite.
              </li>
            </ul>
          </Box>
          <Box fontSize="18px" mb="10px" mt="10px">
            Basic Qualifications:
          </Box>
          <Box fontSize="16px">
            <ul>
              <li>
                Minimum of 3 years of frontend software engineering experience,
                preferably in a JavaScript environment
              </li>
              <li>
                Practical experience with modern JavaScript UI libraries and
                frameworks (e.g., React, Angular, Vue)
              </li>
              <li>
                Deep understanding of the JavaScript language (ECMAScript
                2015+), HTML5 and CSS
              </li>
              <li>
                Knowledge of front-end architecture especially in designing
                large scale single-page applications
              </li>
              <li>
                Understanding of fundamental design skills (e.g., color,
                typography, layout, etc.) and passion for developing intuitive
                and responsive interfaces
              </li>
            </ul>
          </Box>
          <Box fontSize="18px" mb="10px" mt="10px">
            Desirable Skills:
          </Box>
          <Box fontSize="16px">
            <ul>
              <li>Start-up experience</li>
              {/* eslint-disable-next-line react/no-unescaped-entities */}
              <li>
                Experience with visualization libraries like D3 a solid plus
              </li>
              <li>"Get things done" attitude</li>
            </ul>
          </Box>
          <Box fontSize="18px" mb="10px" mt="10px">
            Benefits:
          </Box>
          <Box fontSize="16px">
            <ul>
              <li>Competitive salary</li>
              <li>Key role in a small but strong and growing team</li>
              <li>Flexible work hours and holiday policy</li>
              <li>Open and collaborative work culture</li>
            </ul>
          </Box>
        </React.Fragment>
      ),
    },
    {
      position: "Business Analyst",
      location: "Engineering Team, Bengaluru",
      applyLink:
        "https://angel.co/company/pepper-cloud-pte-1/jobs/2138021-business-analyst",
      open: false,
      content: (
        <React.Fragment>
          <Box fontSize="16px">
            We are looking for an experienced
            <ul>
              <li>
                Business Analyst to manage the functional and non-functional
                requirement of our various products and their features.
              </li>
              <li>
                The person should have strong observational, and analytical
                skills to breakdown the business and product requirement in
                ‘easy to comprehend’ user stories.
              </li>
              <li>
                The person would act as a strong bridge between the business and
                technical team and would be responsible for driving new product
                features.
              </li>
            </ul>
            <Box fontSize="18px" mb="10px" mt="10px">
              Key Job Responsibilities:
            </Box>
            <ul>
              <li>
                Gathering business and functional requirements and document them
                in clear and concise format, which is focused on the reader and
                is without unnecessary detail.
              </li>
              <li>
                Translating these business needs in to BRD, use cases/ user
                stories, process flows, data flows, UI specifications and wire
                frames and other supporting requirement documentation to be
                utilized in an agile development environment.
              </li>
              <li>
                Proficient with tools like Jira, Confluence, Balsamiq, Axure,
                Mockplus, Draw.io, Visio, etc.
              </li>
              <li>
                Work closely with the business and technology team to gather &
                write end to end business testing requirements and acceptance
                criteria.
              </li>
              <li>
                Demonstrate new functionality to business and technology users.
                Interact with the business users and convey the information to
                the developers
              </li>
              <li>
                Review and approve functional test scenarios and perform testing
                as necessary for team to meet iteration goals.
              </li>
            </ul>
          </Box>
          <Box fontSize="18px" mb="10px" mt="10px">
            Basic Qualifications:
          </Box>
          <Box fontSize="16px">
            <ul>
              <li>
                2-4 yrs. of hands on experience in software applications as a
                Business Analyst. Well versed with IT technologies
              </li>
              <li>Masters or Bachelor Degree</li>
              <li>
                Strong analytical skills; Attentive listener; Ability to solve
                complex problems.
              </li>
            </ul>
          </Box>
          <Box fontSize="18px" mb="10px" mt="10px">
            Desirable Skills:
          </Box>
          <Box fontSize="16px">
            <ul>
              <li>Exceptional written and verbal communication skills.</li>
              {/* eslint-disable-next-line react/no-unescaped-entities */}
              <li>
                Ability to multitask and work on a diverse range of
                requirements.
              </li>
              <li>Strong teamwork and interpersonal skills</li>
              <li>Ability to read and interpret technical specifications.</li>
              <li>
                Ability to comprehend audience background and expectations.
              </li>
              <li>Ability to correctly prioritize work and meet deadlines.</li>
              <li>
                Self - motivated, flexible, and comfortable with a fast - paced
                startup
              </li>
            </ul>
          </Box>
          <Box fontSize="18px" mb="10px" mt="10px">
            Benefits:
          </Box>
          <Box fontSize="16px">
            <ul>
              <li>Competitive salary</li>
              <li>Flexible work hours and holiday policy</li>
            </ul>
          </Box>
        </React.Fragment>
      ),
    },
    {
      position: "Junior UI UX Designer",
      location: "Design Team, Bengaluru",
      applyLink:
        "https://angel.co/company/pepper-cloud-pte-1/jobs/1311990-senior-ui-ux-designer",
      open: false,
      content: (
        <React.Fragment>
          <Box fontSize="16px">
            We are looking for an experienced and passionate designer to join
            our growing product and design team who can:
            <ul>
              <li>
                Design intuitive interfaces, flows, and experiences for web,
                mobile, and other form factors
              </li>
              <li>
                Translate broad, ambiguous ideas and business requirements into
                delightful and conversion-oriented user journeys, with a high
                degree of autonomy
              </li>
              <li>
                Lead the design process all the way from discovery and analysis,
                creating user flows, wireframes and storyboards to building user
                interface mockups and prototypes
              </li>
              <li>
                Work in an interdisciplinary environment involving designers,
                user researchers, product managers, and engineers to brainstorm
                and shape product design
              </li>
              <li>Build an updated visual language for our product suite.</li>
              <li>
                Stay up-to-date and educate internal members on evolving design
                trends and best practices in the B2B/B2C space.
              </li>
            </ul>
          </Box>
          <Box fontSize="18px" mb="10px" mt="10px">
            Basic Qualifications:
          </Box>
          <Box fontSize="16px">
            <ul>
              <li>
                2+ years of hands-on experience in designing and shipping
                products across web and mobile.
              </li>
              <li>
                2+ years of experience in interaction and visual design,
                preferably in a B2B/B2C domain
              </li>
              <li>
                Fluency with responsive web design principles and guidelines.
              </li>
              <li>
                Proficient knowledge of color theory, grid layout, typography,
                and graphic design.
              </li>
              <li>
                Proficiency with design tools Sketch, Figma, Adobe XD,
                Illustrator (we are tool-agonistic).
              </li>
              <li>
                Solid communication skills, with the ability to clearly
                articulate your design decisions.
              </li>
              <li>
                BA/BS in design-related domain, or equivalent industrial
                experience.
              </li>
            </ul>
          </Box>
          <Box fontSize="18px" mb="10px" mt="10px">
            Desirable Skills:
          </Box>
          <Box fontSize="16px">
            <ul>
              <li>Start-up experience</li>
              <li>Mobile development experience a solid plus</li>
              <li>Experience working with remote teams.</li>
              <li>
                Experience in designing and developing enterprise-grade
                applications is a solid plus.
              </li>
            </ul>
          </Box>
          <Box fontSize="18px" mb="10px" mt="10px">
            Benefits:
          </Box>
          <Box fontSize="16px">
            <ul>
              <li>Competitive salary</li>
              <li>Flexible work hours and holiday policy</li>
              <li>Open and collaborative work culture</li>
            </ul>
          </Box>
        </React.Fragment>
      ),
    },
    {
      position: "Graphics Designer",
      location: "Design Team, Bengaluru",
      applyLink:
        "https://angel.co/company/pepper-cloud-pte-1/jobs/2051108-graphics-designer",
      open: true,
      content: (
        <React.Fragment>
          <Box fontSize="16px">
            We are looking for an experienced and passionate Graphics designer
            to join our growing product and design team who has:
            <ul>
              <li>Minimum 2yrs of work experience.</li>
              <li>
                Advertising Agency Experience, Graphic Design Skills, Layout
                Skills, Creative Ideation, Customer Focus, Creativity,
                Flexibility, Attention to Detail, Deadline-Oriented, Acute
                Vision, Illustration, Sketching.
              </li>
              <li>
                Skilled with Photoshop, Corel DRAW, Illustrator, InDesign, and
                other Adobe Creative Cloud Tools.
              </li>
              <li>
                Create digital assets for the brand – newsletters, brochure,
                EDMs, landing pages etc.
              </li>
              <li>
                Ideating, Conceptualizing and Designing original pieces,
                including social media posts, animation, illustrations and
                infographics.
              </li>
              <li>Work on a consistent theme and layout.</li>
              <li>
                Should be creative with colors, fonts, layouts, icons,
                illustrations.
              </li>
              <li>
                Provide ideas and concepts and developing an interactive design
                for the same with an understanding of all the latest trends.
              </li>
            </ul>
          </Box>
          <Box fontSize="18px" mb="10px" mt="10px">
            Desirable Skills:
          </Box>
          <Box fontSize="16px">
            <ul>
              <li>Start-up experience and working with remote teams.</li>
              <li>Degree/Diploma in Arts/Designing.</li>
              <li>
                Experience in designing and developing enterprise-grade
                applications is a solid plus.
              </li>
            </ul>
          </Box>
          <Box fontSize="18px" mb="10px" mt="10px">
            Benefits:
          </Box>
          <Box fontSize="16px">
            <ul>
              <li>Competitive salary</li>
              <li>Flexible work hours and holiday policy</li>
              <li>Open and collaborative work culture</li>
            </ul>
          </Box>
        </React.Fragment>
      ),
    },
    {
      position: "Inside Sales Executive",
      location: "Marketing Team, Bengaluru",
      applyLink:
        "https://angel.co/company/pepper-cloud-pte-1/jobs/1767448-inside-sales-executive",
      open: false,
      content: (
        <React.Fragment>
          <Box fontSize="16px">
            We are looking for an Inside Sales Manager preferably someone from
            technology sales background. You will be responsible for:
            <ul>
              <li>Selling to SE Asia Markets.</li>
              <li>
                Generate new business by prospecting, cold calling, leveraging
                networks, etc
              </li>
              <li>
                Understanding of tools such as LinkedIn, Mailchimp, and CRM to
                establish and build relationships in order to generate and
                qualify leads.
              </li>
              <li>A proven track record in a fast-paced sales environment</li>
              <li>
                Quota - Meeting and exceeding monthly, quarterly, and annual
                quotas
              </li>
              <li>
                Having the ability to share/receive constructive feedback on the
                quality of leads, expectations, and overall pipeline health
              </li>
              <li>
                Using internal CRM, complete and report 50-70 daily outbound
                activities
              </li>
              <li>
                Incentive driven. Willing to adopt a performance-based sales
                model by tracking critical sales metrics and keeping CRM updated
                daily
              </li>
            </ul>
          </Box>
          <Box fontSize="18px" mb="10px" mt="10px">
            Basic Qualifications:
          </Box>
          <Box fontSize="16px">
            <ul>
              <li>Experience in SAAS selling to SMB/SME.</li>
              <li>
                2-3 years inside sales experience, preferably in technology
                sales
              </li>
              <li>Excellent command over English.</li>
              <li>
                Strong verbal and written communication skills with the ability
                to deliver powerful presentations and product demos.
              </li>
            </ul>
          </Box>
          <Box fontSize="18px" mb="10px" mt="10px">
            Desirable Skills:
          </Box>
          <Box fontSize="16px">
            <ul>
              <li>Start-up experience</li>
              <li>"Get things done" attitude</li>
              <li>Experience working with remote teams.</li>
            </ul>
          </Box>
          <Box fontSize="18px" mb="10px" mt="10px">
            Benefits:
          </Box>
          <Box fontSize="16px">
            <ul>
              <li>Competitive salary</li>
              <li>Fixed annual bonus</li>
              <li>Flexible work hours and holiday policy</li>
              <li>Open and collaborative work culture</li>
            </ul>
          </Box>
        </React.Fragment>
      ),
    },
    {
      position: "QA Engineer",
      location: "Engineering Team, Bengaluru",
      applyLink:
        "https://angel.co/company/pepper-cloud-pte-1/jobs/2012537-qa-engineer",
      open: false,
      content: (
        <React.Fragment>
          <Box fontSize="16px">
            We are looking for a passionate full stack QA engineer to design and
            execute manual and automated testing for our core product offerings.
            You will be a core member of the engineering team who can:
            <ul>
              <li>
                Create detailed, comprehensive and well-structured test plans
                and test cases as per business requirements and technical
                specifications
              </li>
              <li>
                Lead end-to-end manual (and preferably automation) testing for
                both frontend (browser) and backend (API) applications
              </li>
              <li>
                Perform thorough regression testing for functional and
                non-functional product features
              </li>
              <li>
                Collaborate with full stack engineers and product managers to
                identify and understand feature requirements
              </li>
              <li>
                Gathering business and functional requirements and document them
                in clear and concise format, which is focused on the reader and
                is without unnecessary detail
              </li>
            </ul>
          </Box>
          <Box fontSize="18px" mb="10px" mt="10px">
            Basic Qualifications:
          </Box>
          <Box fontSize="16px">
            <ul>
              <li>
                Minimum of 4 years of quality assurance and test engineering
                experience
              </li>
              <li>
                Proven experience in writing clear, concise and comprehensive
                test plans and test cases
              </li>
              <li>Experience in testing enterprise-grade SaaS applications</li>
              <li>Strong analytical and problem-solving skills</li>
              <li>
                Basic understanding of JavaScript based test automation tools
                and frameworks (Cypress, Mocha) preferred
              </li>
              <li>
                Team player with an ability to work efficiently with a high
                degree of autonomy
              </li>
              <li>Familiarity with tools such as Postman, Jira, GIT</li>
              <li>
                Bachelor’s degree in Computer Science, Computer Engineering,
                Electrical Engineering or equivalent.
              </li>
            </ul>
          </Box>
          <Box fontSize="18px" mb="10px" mt="10px">
            Desirable Skills:
          </Box>
          <Box fontSize="16px">
            <ul>
              <li>Start-up experience</li>
              <li>"Get things done" attitude</li>
              <li>Experience working with remote teams</li>
              <li>
                Experience with performance and/or security testing is a solid
                plus
              </li>
            </ul>
          </Box>
          <Box fontSize="18px" mb="10px" mt="10px">
            Benefits:
          </Box>
          <Box fontSize="16px">
            <ul>
              <li>Competitive salary</li>
              <li>Fixed annual bonus</li>
              <li>Flexible work hours and holiday policy</li>
              <li>Open and collaborative work culture</li>
            </ul>
          </Box>
        </React.Fragment>
      ),
    },
    {
      position: "Digital Marketing Manager",
      location: "Marketing Team, Bengaluru",
      applyLink:
        "https://angel.co/company/pepper-cloud-pte-1/jobs/1872205-digital-marketing-manager",
      open: false,
      content: (
        <React.Fragment>
          <Box fontSize="16px">
            We are looking for an experienced and passionate Digital Marketing
            Manager, who can lead our efforts in digital marketing to increase
            our brand visibility & lead generation.
            <ul>
              <li>
                The ideal candidate will expand the company's brand presence by
                finding the target audience to distribute marketing content to.
              </li>
              <li>
                You will create and implement the marketing strategy using both
                offline and online methods to gain new customers.
              </li>
              <li>
                The ideal candidate is both a self-motivated individual and a
                positive team player.
              </li>
            </ul>
          </Box>
          <Box fontSize="18px" mb="10px" mt="10px">
            Job Responsibilities
          </Box>
          <Box fontSize="16px">
            <ul>
              <li>
                Optimize website content for maximum visibility and ranking on
                major search engines.Drive external traffic to generate
                conversions for new leads and also for branding purposes.
              </li>
              <li>
                Execute all digital marketing campaigns according to the
                Marketing roadmap, including SEO/SEM, paid social media and
                display advertising campaigns. From campaign set up to
                optimization.
              </li>
              <li>
                Structure and style emails, make tweaks to landing pages,
                customize forms, format blog posts, and more.
              </li>
              <li>
                Develop an overall Social Media Marketing Plan and Strategy and
                work with copy writers & designers to develop campaign pages,
                banners and online promotional material.
              </li>
              <li>
                Must be able to support setting up new automated email
                campaigns. Experience in working with Mailchimp, Active Campaign
                etc.
              </li>
              <li>
                Measure and report performance of all digital marketing
                campaigns, and assess against goals (ROI and KPIs). Analyze and
                optimize user funnels, tracking, audience targeting.
              </li>
            </ul>
          </Box>
          <Box fontSize="18px" mb="10px" mt="10px">
            Required Skills:
          </Box>
          <Box fontSize="16px">
            <ul>
              <li>
                3+ year’s full-time experience in digital marketing (B2B
                marketing in SaaS background preferred).
              </li>
              <li>Email campaigns management experience is a must.</li>
              <li>
                Good knowledge of on page and off page SEO
                strategies/techniques. Broader experience in Paid, Owned and
                Earned media (search, programmatic, performance marketing,
                analytics, site builds and content, social media, influencer
                engagement etc)
              </li>
              <li>Good knowledge of SEM and PPC campaigns.</li>
              <li>
                Strong knowledge of search engine algorithms and ranking
                strategies.
              </li>
              <li>
                Ability to identify and isolate trending keywords for a given
                topic and/ or different geographical locations.
              </li>
              <li>
                Ability to work with social media channels like Facebook,
                Twitter, LinkedIn, Blogs, etc
              </li>
              <li>Excellent communication skills, both verbal and written.</li>
            </ul>
          </Box>
          <Box fontSize="18px" mb="10px" mt="10px">
            Benefits:
          </Box>
          <Box fontSize="16px">
            <ul>
              <li>Competitive salary</li>
              <li>Flexible work hours and holiday policy</li>
              <li>Open and collaborative work culture</li>
            </ul>
          </Box>
        </React.Fragment>
      ),
    },
  ];
  return (
    <div className={classes.root}>
      <SEO  
        canonical="/careers/"
        description="Build your career with Singapore's #1 sales CRM software. Progress in your career path and succeed with us while redefining the customer relationships. Check out open job positions. Apply now!"
        keywords="Career,CRM Career path, CRM Career,jobs in singapore,CRM related jobs "
        pathname="/careers/"
        title="Careers and Jobs | Pepper Cloud CRM"
      />
      <Box className={classes.heroSection}>
        <Container style={{ position: "relative", zIndex: 1 }}>
          <Box className={classes.heroContent}>
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: false }}
            >
              <HeaderTypography
                className={classes.bannerHeading}
                component="h1"
                mb={2}
                mt={0}
                overrideClassName
                textAlign="center"
              >
                Pursuit of a{" "}
                <span
                    style={{
                      background: "linear-gradient(90deg, #208EEC, #009A99)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                      backgroundClip: "text",
                    }}
                  >
                    successful career
                  </span>
                <br />
                is within your reach
              </HeaderTypography>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.15 }}
              viewport={{ once: false }}
            >
              <ParagraphTypography
                className={classes.sectionSubheading}
                textAlign="center"
                style={{ margin: "0 auto 50px", maxWidth: 720 }}
              >
                Join a team that&apos;s revolutionising AI WhatsApp  CRM across Southeast Asia.
                We&apos;re building the future of sales automation and customer
                relationships.
              </ParagraphTypography>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.25 }}
              viewport={{ once: false }}
              style={{ display: "flex", justifyContent: "center" }}
            >
              <Button
                className={classes.heroBtn}
                color="secondary"
                href={"https://angel.co/company/pepper-cloud-pte-1/jobs"}
                rel="nofollow"
                target="_blank"
                variant="contained"
              >
                View open positions
              </Button>
            </motion.div>
          </Box>
        </Container>
      </Box>
      {/* Thrive & grow with us section */}
      <Box
        alignItems="center"
        component={Container}
        display="flex !important"
        flexDirection="column"
        maxWidth="md"
        py={8}
        textAlign="center"
      >
          <Box className={classes.thrivePhotoWrapper} mb={7} ref={thriveGridRef}>
            <Box className={classes.thrivePhotoGrid}>
              <Box className={classes.thrivePhotoCell} style={["xs","sm"].includes(width) ? { gridColumn: 2, gridRow: 3 } : {}}>
                {!["xs","sm"].includes(width) && <motion.div className={classes.thrivePhotoSkeleton} style={{ opacity: skeletonO }} />}
                <motion.img alt="" className={classes.thrivePhoto} src={floatingImg2} style={["xs","sm"].includes(width) ? {} : { x: img2X, y: img2Y, rotate: img2R, scale: imgScale }} />
              </Box>
              <Box className={classes.thrivePhotoCellWide} style={["xs","sm"].includes(width) ? { gridColumn: "span 2", gridRow: 1 } : {}}>
                {!["xs","sm"].includes(width) && <motion.div className={classes.thrivePhotoSkeleton} style={{ opacity: skeletonO }} />}
                <motion.img alt="" className={classes.thrivePhotoWide} src={floatingImg5} style={["xs","sm"].includes(width) ? {} : { x: img5X, y: img5Y, rotate: img5R, scale: imgScale }} />
              </Box>
              <Box className={classes.thrivePhotoCellTall} style={["xs","sm"].includes(width) ? { gridColumn: 1, gridRow: "2 / 4" } : {}}>
                {!["xs","sm"].includes(width) && <motion.div className={classes.thrivePhotoSkeleton} style={{ opacity: skeletonO }} />}
                <motion.img alt="" className={classes.thrivePhotoTall} src={floatingImg4} style={["xs","sm"].includes(width) ? {} : { x: img4X, y: img4Y, rotate: img4R, scale: imgScale }} />
              </Box>
              <Box className={classes.thrivePhotoCell} style={["xs","sm"].includes(width) ? { gridColumn: 2, gridRow: 2 } : {}}>
                {!["xs","sm"].includes(width) && <motion.div className={classes.thrivePhotoSkeleton} style={{ opacity: skeletonO }} />}
                <motion.img alt="" className={classes.thrivePhoto} src={floatingImg6} style={["xs","sm"].includes(width) ? {} : { x: img6X, y: img6Y, rotate: img6R, scale: imgScale }} />
              </Box>
              <Box className={classes.thrivePhotoCell} style={["xs","sm"].includes(width) ? { gridColumn: 1, gridRow: 4 } : {}}>
                {!["xs","sm"].includes(width) && <motion.div className={classes.thrivePhotoSkeleton} style={{ opacity: skeletonO }} />}
                <motion.img alt="" className={classes.thrivePhoto} src={floatingImg7} style={["xs","sm"].includes(width) ? {} : { x: img7X, y: img7Y, rotate: img7R, scale: imgScale }} />
              </Box>
              <Box className={classes.thrivePhotoCell} style={["xs","sm"].includes(width) ? { gridColumn: 2, gridRow: 4 } : {}}>
                {!["xs","sm"].includes(width) && <motion.div className={classes.thrivePhotoSkeleton} style={{ opacity: skeletonO }} />}
                <motion.img alt="" className={classes.thrivePhoto} src={floatingImg3} style={["xs","sm"].includes(width) ? {} : { x: img3X, y: img3Y, rotate: img3R, scale: imgScale }} />
              </Box>
            </Box>
          </Box>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: false }}
        >
          <HeaderTypography
            className={classes.sectionTitle}
            component="h2"
            mt={0}
            overrideClassName
            textAlign="center"
          >
            Thrive &amp; grow with us
          </HeaderTypography>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.15 }}
          viewport={{ once: false }}
        >
          <ParagraphTypography
            className={classes.sectionSubheading}
            textAlign="center"
            marginBottom={2}
          >
            At Pepper Cloud, we believe in nurturing talent and fostering innovation. Our culture is built on collaboration, continuous learning, and the pursuit of excellence. We provide the tools, mentorship, and environment you need to reach your full potential while making a meaningful impact on businesses across the region.
          </ParagraphTypography>
          <ParagraphTypography
            className={classes.sectionSubheading}
            textAlign="center"
          >
            From flexible work arrangements to comprehensive professional development programs, we&apos;re committed to your success and well-being every step of the way.
          </ParagraphTypography>
        </motion.div>
      </Box>
     
      <Box
        className={classes.lifeAtPepperSection}
        py={8}
      >
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: false }}
          >
            <HeaderTypography
              className={classes.sectionTitle}
              component="h2"
              mt={0}
              overrideClassName
              textAlign="center"
            >
              Life at Pepper Cloud
            </HeaderTypography>
          </motion.div>

          <Grid container spacing={3}>
            {LifeAtPepperCloud.map((each, idx) => (
              <Grid item key={each.title} md={4} sm={6} xs={12}>
                <motion.div
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: idx * 0.1 }}
                  viewport={{ once: false }}
                  style={{ height: "100%" }}
                >
                  <Box className={classes.lifeAtPepperCard}>
                    <Box
                      className={classes.cardIconBox}
                      style={{ background: each.color }}
                    >
                      <Box
                        alt={each.alt}
                        className={classes.cardIconImg}
                        component="img"
                        src={each.logo}
                      />
                    </Box>
                    <HeaderTypography
                      component="h3"
                      fontSize={24}
                      fontWeight={600}
                      m={0}
                      textAlign="left"
                    >
                      {each.title}
                    </HeaderTypography>
                    <ParagraphTypography
                      color="text.paragraph"
                      fontSize={15}
                      mb={0}
                      mt={2}
                      textAlign="left"
                    >
                      {each.description}
                    </ParagraphTypography>
                  </Box>
                </motion.div>
              </Grid>
            ))}
          </Grid>
        </div>
      </Box>
      <Box className={classes.featuredJobsSection}>
        <img alt="" className={classes.featuredJobsBgImg} src={jobsBg} />
        <Box className={classes.featuredJobsGradient} />
        <Box className={classes.featuredJobsContent}>
          <Box className="container">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: false }}
            >
              <Typography className={classes.featuredJobsTitle} component="h2">
                Featured jobs
              </Typography>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.15 }}
              viewport={{ once: false }}
            >
              <Typography className={classes.featuredJobsDesc}>
                Our philosophy is simple — hire a team of diverse, passionate people and foster a culture that empowers you to do your best work.
              </Typography>
            </motion.div>
            <Box mt={6} textAlign="left">
              {jobDetails.map((each, index) => (
                <motion.div
                  // eslint-disable-next-line react/no-array-index-key
                  key={index}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.08 }}
                  viewport={{ once: false }}
                >
                  <FeaturedOpening
                    each={each}
                    open={index === open}
                    setChange={() => setOpen(index === open ? -1 : index)}
                  />
                </motion.div>
              ))}
            </Box>
            </Box>
        </Box>
      </Box>
      <Box  py={8}>

      <Box className="container">
        <Grid container spacing={6} alignItems="flex-start">
          <Grid item md={5} sm={12} xs={12}>
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: false }}
            >
              <HeaderTypography
                className={classes.sectionTitle}
                component="h2"
                mt={0}
                overrideClassName
                textAlign={{ sm: "center", xs: "center" }[width] || "left"}
              >
                Our Principles
              </HeaderTypography>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.15 }}
              viewport={{ once: false }}
            >
              <ParagraphTypography
                color="text.paragraph"
                mb={4}
                fontWeight={500}
                fontSize={16}
                textAlign={{ sm: "center", xs: "center" }[width] || "left"}
              >
                We strongly believe that true success is an outcome of our work
                principles. Our principles serve as the foundation of our belief
                and behaviour.
              </ParagraphTypography>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.25 }}
              viewport={{ once: false }}
            >
              <Box
                alt="Pepper Cloud team member working on a laptop"
                className={classes.principlesImage}
                component="img"
                src={floatingImg1}
              />
            </motion.div>
          </Grid>
          <Grid item md={7} sm={12} xs={12}>
            <Grid container spacing={4}>
              {OurPrinciples.map((each, idx) => (
                <Grid item key={each.title} md={6} sm={6} xs={12}>
                  <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: idx * 0.1 }}
                    viewport={{ once: false }}
                  >
                    <Box>
                      <Box
                        className={classes.cardIconBox}
                        style={{ background: each.color }}
                      >
                        <Box
                          alt={each.alt}
                          className={classes.cardIconImg}
                          component="img"
                          src={each.logo}
                        />
                      </Box>
                      <HeaderTypography
                        component="h3"
                        fontSize={24}
                        fontWeight={600}
                        mb={2}
                        mt={0}
                        textAlign="left"
                      >
                        {each.title}
                      </HeaderTypography>
                      <ParagraphTypography
                        color="text.paragraph"
                        fontSize={15}
                        lineHeight={1.6}
                        mb={0}
                        mt={2}
                        textAlign="left"
                      >
                        {each.description}
                      </ParagraphTypography>
                    </Box>
                  </motion.div>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Box>
      </Box>

      <JoinUs />
    </div>
  );
}

export default careers;
